module.exports = __webpack_public_path__ + "static/img/title2@2x.895bfd3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/SPSR/title2@2x.png
// module id = cUeu
// module chunks = 70